module.exports = "@media only screen and (max-width: 426px) {\n  h2 {\n    margin: 8px 0 5px 0; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard.scss
// module id = ./src/app/components/dashboard/dashboard.scss
// module chunks = main